import { intersection } from 'lodash';

export default {

  methods: {

    /**
     * Sometimes user units persist id of BU that was already deleted from settings. It leads to invalid units
     * displayed in users table or in edit user's business units multiselect. This function filters user's business
     * units to ensure that deleted units will not be displayed
     * @param {Array<string>} currentBusinessUnits current unfiltered business units
     * @param {Array<string>} allAvailableBusinessUnits list of valid business units options
     * @returns {Array<string>}
     */
    getBusinessUnitsWithoutDeletedEntries(currentBusinessUnits, allAvailableBusinessUnits) {
      return intersection(allAvailableBusinessUnits, currentBusinessUnits);
    }, // getBusinessUnitsListWithoutDeletedEntries()

  },
};
